import isEmpty from 'lodash/isEmpty';

export const maskEmail = mailString => {
  if (isEmpty(mailString)) return;

  const prefix = mailString.split('@')[0];
  const postfix = mailString.split('@')[1];
  const indexDot = postfix?.indexOf('.');
  const domainExtension = postfix?.substring(indexDot);
  const mailHost = postfix?.substring(0, indexDot);

  if (isEmpty(postfix) || isEmpty(mailHost) || isEmpty(domainExtension)) return;

  let maskedPrefix = prefix?.split('').map((o, i) => {
    return (i < 2 || i == prefix.length) ? o : '*';
  }).join('');

  let maskedMailHost = mailHost?.split('').map((o, i) => {
    return (i == 0 || i == postfix.length) ? o : '*';
  }).join('');

  return maskedPrefix + '@' + maskedMailHost + domainExtension;
};
